function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapActions, mapState } from 'vuex';
import CustomerInsightsService from '@/apps/customer-insigths/services/customer_insights_service';
import FormReportRegion from '@/apps/customer-insigths/components/FormReportRegion.vue';
export default {
  name: 'RegionsMaintenanceComponent',
  components: {
    FormReportRegion: FormReportRegion
  },
  data: function data() {
    return {
      DIALOG_ADD_REGION: 'DIALOG_CREATE_REGION',
      DIALOG_UPDATE_REGION: 'DIALOG_UPDATE_REGION',
      DIALOG_DELETE_REGION: 'DIALOG_DELETE_REGION',
      keyRegionsTable: 0,
      // keySomos1Reports: 0,
      item: null,
      manage_report_title: 'Editar Region',
      maintenance_init: false
    };
  },
  created: function created() {
    // this.getRegions()
  },
  methods: _objectSpread(_objectSpread({}, mapActions('customer-insights', ['getInitialData'])), {}, {
    onAdd: function onAdd() {
      this.$refs[this.DIALOG_ADD_REGION].onOpen();
    },
    onOpenEditDialog: function onOpenEditDialog(item) {
      this.item = item;
      this.edit = true;
      this.$refs[this.DIALOG_UPDATE_REGION].onOpen();
    },
    onOpenDeleteDialog: function onOpenDeleteDialog(item) {
      this.item = item;
      this.$refs[this.DIALOG_DELETE_REGION].onOpen();
    },
    onConfirmDelete: function onConfirmDelete(event) {
      var _this = this;
      if (event) {
        var params = {
          region: this.item.region.region,
          id_region_dataentry: this.item.region.id_region_dataentry
        };
        CustomerInsightsService.deleteRegion(params).then(function (response) {
          _this.getInitialData();
          _this.keyRegionsTable += 1;
        });
        // CustomerInsightsService.deleteUpdateHour(this.item.document_id).then(response => {
        //   this.getUpdateHours()
        //   this.keyTable += 1
        //   this.item = null
        //   this.updateTime = null
        // })
      }
      this.$refs[this.DIALOG_DELETE_REGION].onClose();
    },
    onSubmitRegion: function onSubmitRegion(params) {
      var _this2 = this;
      // if (!this.updateTime) {
      //   tasks.toast.error('Seleccione una hora de actualización para continuar.')
      //   return
      // }
      var promise = null;
      var modalName = this.DIALOG_ADD_REGION;
      if (this.edit) {
        // promise = CustomerInsightsService.editRegion(this.item.document_id, params)
        modalName = this.DIALOG_UPDATE_REGION;
      } else {
        // promise = CustomerInsightsService.editRegion(params)
        promise = CustomerInsightsService.addRegion(params);
      }
      promise.then(function (response) {
        // this.getInitialData()
        // this.keyRegionsTable += 1
        // this.edit = false
        // this.item = null
        // this.$refs[modalName].onClose()
        _this2.getInitialData();
        _this2.keyRegionsTable += 1;
        // this.resetForm()
        _this2.edit = false;
        _this2.item = null;
        _this2.$refs[modalName].onClose();
      });
    }
  }),
  computed: _objectSpread(_objectSpread({}, mapState('customer-insights', ['regions'])), {}, {
    items: function items() {
      return this.regions.map(function (region) {
        return {
          region: region
        };
      });
    },
    headers: function headers() {
      return [{
        value: 'region.region',
        text: 'Region'
      }, {
        value: 'actions',
        text: ''
      }];
    }
  })
};